<div class="wrapper">
  <div class="loading-circle" [ngClass]="{ margin: hasMargin }"></div>
</div>
